import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Drawer.module.scss'

const DrawerAddButton = ({ onClick, disabled = false, children }) => (
  <button className={classNames(classes.addButton, 'd-inline-flex align-items-center')} onClick={onClick} disabled={disabled}>
    <i className='fa fa-plus' aria-hidden='true' />
    {children}
  </button>
)

DrawerAddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default DrawerAddButton
